import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as styles from './styles.scss';
import i18next from 'i18next';
import { InfoBuyIn } from 'assets/svg';

const CustomTooltipProfitLoss = () => {
  return (
    <div className={styles.CustomTooltipProfitloss}>
      <span>{i18next.t('Unrealized P/L (Value/%)')}</span>
      <OverlayTrigger
        key={'tooltip-profit-loss'}
        overlay={
          <Tooltip id={`tooltip-profit-loss`}>
            {i18next.t('Profit/Loss includes Pending Entitlement Value')}
          </Tooltip>
        }
      >
        <InfoBuyIn width={15} />
      </OverlayTrigger>
    </div>
  );
};

export default CustomTooltipProfitLoss;



// WEBPACK FOOTER //
// ./src/components/areas/Account/Portfolio/CustomTooltipProfitLoss/index.tsx